export const mergeContactLabel = (name: string) =>
	`Merge ${name.trim() || "person"} with...`

export const mergeContactTargets = <T extends { id: string }>(
	contacts: readonly T[],
	currentId: string,
) => contacts.filter((contact) => contact.id !== currentId)

export const mergeContactEmptyMessage = (query: string) =>
	query.trim()
		? "No matching people. The current person is left out of the list."
		: "No other people to merge with."
